/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { Modal } from 'antd';
import { CustomText } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { shouldBlockUnsignedContract } from '../../util/rule';

/**
 * Hook para validações de apontamento
 */
export const useApontamentoValidation = () => {
  const canProccessMensal = (collaboratorsToProcess, setOrderBy) => {
    const collaboratorsWithNegativeNet = collaboratorsToProcess.filter(
      (item) => item.liquido !== undefined && item.liquido < 0
    );
    if (collaboratorsWithNegativeNet.length) {
      Modal.warning({
        title: 'Valor Líquido Negativo',
        content: (
          <div>
            <p>
              Não foi possível prosseguir com a operação, pois existem valores que estão negativos, por favor, ajuste os
              valores.
            </p>
            <p>Serão ordenados os valores negativos ao topo para melhor visualização.</p>
          </div>
        ),
      });
      setOrderBy({ liquido: 'asc' });
      return false;
    }

    const totalEarnings = collaboratorsToProcess.reduce((sum, item) => sum + (item.totalRendimentos || 0), 0);
    if (totalEarnings <= 0) {
      Modal.warning({
        title: 'Total de Rendimentos zerado',
        content: (
          <p>
            Não foi possível prosseguir com a operação, por favor, insira valores em:
            <b>Produção, Variável ou Reembolso</b> para seguir com a operação.
          </p>
        ),
      });
      return false;
    }
    return true;
  };

  const canProccessAdiantamento = (collaboratorsToProcess) => {
    const collaboratorsWithAdvance = collaboratorsToProcess.filter(
      (item) => item.variavel > 0 || item.ajudaCusto > 0 || item.reembolso > 0 || item.adiantamento > 0
    );
    if (!collaboratorsWithAdvance.length) {
      Modal.warning({
        title: 'Total do Adiantamento zerado',
        content: (
          <p>
            Não foi possível prosseguir com a operação, por favor, verifique se os valores estão corretos para que o
            total do adiantamento seja diferente de zero.
          </p>
        ),
      });
      return false;
    }
    return true;
  };

  const getCollaboratorsExceedingReimbursementLimit = (collaboratorsToProcess) =>
    collaboratorsToProcess.reduce((prev, item) => {
      if (item.reembolso > item.cooperator.limiteReembolso) {
        return [...prev, item];
      }
      return prev;
    }, []);

  const validateContracts = (payroll, selectedCollaborators, parameterization) =>
    new Promise((resolve) => {
      const filteredCollaborators = selectedCollaborators.map((selected) =>
        payroll.items.find(({ cooperator }) => cooperator.id === selected)
      );
      const collaboratorsWithoutSignedContract = filteredCollaborators.filter((c) =>
        shouldBlockUnsignedContract(c, parameterization)
      );

      if (collaboratorsWithoutSignedContract.length > 0) {
        Modal.warning({
          className: 'contrato-nao-assinado-modal',
          centered: true,
          width: 560,
          title: (
            <CustomText
              color="var(--text-grey-8)"
              fontSize={16}
            >
              Contratos pendentes
            </CustomText>
          ),
          okText: 'Prosseguir',
          onOk: async () => {
            resolve({ ok: true });
          },
          content: (
            <>
              <p>
                Durante o processo de importação foram identificados cooperados com ausência de assinatura ao contrato
                de adesão à Cooperativa.
              </p>
              <ul style={{ maxHeight: '170px', overflow: 'auto' }}>
                {collaboratorsWithoutSignedContract.map((c) => (
                  <li key={c.cpf}>
                    {c.cpf} - {c.nome}
                  </li>
                ))}
              </ul>
              {collaboratorsWithoutSignedContract.length > 0 && (
                <p>
                  Estes cooperados terão seus <b>valores zerados e bloqueados</b> para edição. Você pode prosseguir com
                  o(s) pagamento(s) à <b>este(s)</b> cooperado(s) após a assinatura do(s) contratos(s) de adesão.
                </p>
              )}
            </>
          ),
        });
      } else {
        resolve({ ok: true });
      }
    });

  const validateParameterizedEmail = (parameterization) =>
    new Promise((resolve) => {
      const managerEmail = parameterization.email_alerta;

      if (!managerEmail) {
        Modal.confirm({
          centered: true,
          width: 560,
          title: (
            <CustomText
              color="var(--text-grey-8)"
              fontSize={16}
            >
              E-mail ausente
            </CustomText>
          ),
          cancelButtonProps: { style: { display: 'none' }, disabled: true },
          okText: 'Entendi',
          onOk: async () => {
            resolve({ ok: false });
          },
          content: <p>O e-mail para alerta do Facilitador não foi definido no regulamento</p>,
        });
      } else {
        resolve({ ok: true });
      }
    });

  const contemApontamentoComColaboradorSemContratoAssinado = (payroll, parameterization) => {
    const collaboratorsWithoutSignedContract = payroll.items.filter((item) =>
      shouldBlockUnsignedContract(item.cooperator, parameterization)
    );
    if (collaboratorsWithoutSignedContract.length > 0 && !payroll.isCanceled) {
      Modal.warning({
        className: 'colaboradores-sem-contrato-modal',
        centered: true,
        width: 560,
        title: (
          <CustomText
            color="var(--text-grey-8)"
            fontSize={16}
          >
            Cooperados sem Contrato Assinado
          </CustomText>
        ),
        okText: 'Prosseguir',
        content: (
          <>
            <p>
              Identificamos que têm cooperados que não possuem contrato assinado com a Cooperativa e para sua segurança
              seus devidos pagamentos foram bloqueados.
            </p>
            <p>Ao prosseguir, os valores destinados à estes profissionais serão zerados e bloqueados para edição.</p>
          </>
        ),
      });
    }

    return collaboratorsWithoutSignedContract.length > 0;
  };

  return {
    canProccessMensal,
    canProccessAdiantamento,
    getColaboradoresExcedeLimiteReembolso: getCollaboratorsExceedingReimbursementLimit,
    validarContratos: validateContracts,
    validaEmailParametrizado: validateParameterizedEmail,
    contemApontamentoComColaboradorSemContratoAssinado,
  };
};
